import React from 'react';
import classNames from 'classnames';
import Image from 'next/legacy/image';
import { StarRating } from '$quantum/atoms/StarRating';
import { ReviewProvider } from '$constants/review-providers';

import styles from './index.module.scss';

export interface TrustPilotReviewManualProps {
  readonly rating: number;
  readonly totalReviews?: number;
  readonly basedOnText?: string;
  readonly reviewsText?: string;
  readonly link?: string;
}

export function TrustPilotReviewManual({
  rating,
  basedOnText,
  reviewsText,
  link,
  totalReviews,
}: TrustPilotReviewManualProps): JSX.Element {
  return (
    <div className={classNames(TrustPilotReviewManual.displayName, styles.component)}>
      <div className={styles.scoreWrapper}>
        <p className={styles.score}>{rating.toFixed(1)}</p>
        <StarRating
          className={styles.starRating}
          provider={ReviewProvider.TRUSTPILOT}
          stars={rating}
          starColor="#219653"
        />
      </div>
      {totalReviews && (
        <p className={styles.reviewsText}>
          {basedOnText && <span>{basedOnText}</span>}{' '}
          <a className={styles.reviewsLink} href={link} rel="noreferrer noopener">
            {totalReviews} {reviewsText}
          </a>
        </p>
      )}
      <Image
        className="usp-image"
        src="/img/svg/Trustpilot.svg"
        alt="Trust Pilot logo"
        layout="fixed"
        width={85}
        height={24}
      />
    </div>
  );
}
TrustPilotReviewManual.displayName = 'TrustPilotReviewManual';
